import { remoteConfigDefaults } from '@/plugins/firebase'
export default () => ({
  globalVariable: {
    PlusPayPaymentID: 5
  },
  windowWidth: 0,
  mobileWidth: 768,
  appVersion: {
    ios: remoteConfigDefaults.smartdaily_appversion_ios,
    android: remoteConfigDefaults.smartdaily_appversion_android
  },
  payment: {
    creditCard: {
      id: 1,
      label: '信用卡'
    },
    applePay: {
      id: 8,
      available: null,
      label: 'Apple Pay'
    },
    googlePay: {
      id: 7,
      available: null,
      label: 'Google Pay'
    },
    plusPay: {
      id: 5,
      available: true,
      label: 'Plus Pay'
    }
  },
  toast: {
    isOpen: false,
    type: 'info',
    text: ''
  },
  imageBrowser: {
    isOpen: false,
    activeIndex: 0,
    imageList: []
  },
  registerSuccessDialog: false,
  bannerList: {
    homepage: null
  },
  serviceData: {},
  cityArea: [],
  allCityArea: [],
  channelTypeList: [],
  userDefaultCommunity: null,
  personalInfo: {
    receipt: {},
    address: [],
    community: [],
    contacts: []
  },
  meta: {
    title: '智樂家',
    titleTemple: ' | 智樂家',
    description: process.env.META_DESCRIPTION
  },
  postBody: null,
  postError: null,
  agentOrder: {
    token: null,
    adminConsultationId: null,
    source: '',
    tempPersonalInfo: null
  },
  guestPurchase: {
    createGuestAccountData: null,
    orderSuccess: { status: false, serviceId: null, orderId: null }
  },
  isGuestMember: null,
  serviceRatingDialogOpen: false,
  url: {
    line: 'https://line.me/R/ti/p/@ljs8129j' // line連結（universal link，未安裝 LINE 時可落回網頁）
  },
  sentryConfig: {
    tracing: false,
    tracingHeaderKey: 'X-Correlation-ID',
    tracingHeaderValue: ''
  },
  isFromFacebookAds: false,
  isApp: false, // 來源是否為 app
  deviceCode: null, // App 來源時的 deviceCode
  appServiceAccountId: null, // 登入的app會員id
  appNativeVersion: null, // App 原生版本號，用於功能版本門檻判斷
  bottomUpDestroyTimeout: null,
  shouldClearCache: false // 標記是否需要清除快取
})
